'use client'

import React, { useState, useCallback, useEffect } from 'react'
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useResizeObserver } from '@wojtekmaj/react-hooks';


export default function DocumentRender(props: { documentURL: string, loadSuccessHandler?: () => void }) {
  
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>();
  const [docMinHeight, setDocMinHeight] = useState<number>(550);
  const [docLoadCheck, setDocLoadCheck] = useState<boolean>(false);

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);
  const resizeObserverOptions = {};
  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  const maxWidth = 1024;

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
    setDocLoadCheck(true);
  }

  useEffect(() => {
    if (containerRef) {
      const height = containerRef.clientHeight;
      setDocMinHeight(height);
    }
  }, [docLoadCheck, containerRef]);

  return (
    <div className="document-wrapper" ref={setContainerRef} style={{ minHeight: docMinHeight + 'px'}}>
      <Document file={props.documentURL} onLoadSuccess={onDocumentLoadSuccess}>
        <Page
          key={`page_${pageNumber}`}
          pageNumber={pageNumber}
          width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
        />
      </Document>
      <div className="document-render__controls flex flex-row items-center justify-center mt-4 mb-8">
        <button className={`t2-button t2-button--primary mr-4 px-4 ${!(pageNumber >= 2) && 'document-render__controls--disabled'}`} onClick={(() => setPageNumber((pageNumber - 1)))}>Prev</button>
        <div className="mx-4">Page {pageNumber} of {numPages}</div>
        <button className={`t2-button t2-button--primary ml-4 px-4 ${!(pageNumber < numPages) && 'document-render__controls--disabled'}`} onClick={(() => setPageNumber((pageNumber + 1)))}>Next</button>
      </div>
    </div>
  );
};
